import { render } from "./np-snackbar.vue?vue&type=template&id=4689150a&scoped=true"
import script from "./np-snackbar.vue?vue&type=script&lang=js"
export * from "./np-snackbar.vue?vue&type=script&lang=js"

import "./np-snackbar.vue?vue&type=style&index=0&id=4689150a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4689150a"]])

export default __exports__